module.exports = {"name":"EducatorAdmin","parameters":[{"name":"enableAcceleratedPlatformAccessForContentCreators","valid":[false,true],"value":false}]}